import fitvids from 'fitvids';

// Resize videos in Redactor content
fitvids('figure');